import { useState, useEffect, useCallback, useMemo } from "react";
import { fetchFilteredCarbonRetirements } from "../../config/wilder_requests";

export function useB4CarbonRetirements() {
  const [retirements, setRetirements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const list = await fetchFilteredCarbonRetirements();
      setRetirements(list);
    } catch (err) {
      console.error("Erro ao buscar aposentadorias:", err);
      setError(err.message || "Erro ao carregar compensações");
      setRetirements([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const totalCredits = useMemo(
    () =>
      retirements.reduce((sum, item) => {
        const qty = Number(item.Quantity);
        return sum + (Number.isFinite(qty) ? qty : 0);
      }, 0),
    [retirements]
  );

  return { retirements, loading, error, totalCredits, reload: load };
}
